export default __webpack_public_path__ + "static/media/brief-3.f8130ae8.webp";